/* tslint:disable */

declare var Object: any;
export interface SFOvtCancelRequestSF6Interface {
  "id"?: number;
}

export class SFOvtCancelRequestSF6 implements SFOvtCancelRequestSF6Interface {
  "id": number;
  constructor(data?: SFOvtCancelRequestSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOvtCancelRequestSF6`.
   */
  public static getModelName() {
    return "SFOvtCancelRequestSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOvtCancelRequestSF6 for dynamic purposes.
  **/
  public static factory(data: SFOvtCancelRequestSF6Interface): SFOvtCancelRequestSF6{
    return new SFOvtCancelRequestSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOvtCancelRequestSF6',
      plural: 'SFOvtCancelRequestSF6s',
      path: 'SFOvtCancelRequestSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOvtCancelRequestSF6.ts